import { render, staticRenderFns } from "./CategoryImagesField.vue?vue&type=template&id=0ae7056c&scoped=true"
import script from "./CategoryImagesField.vue?vue&type=script&lang=ts"
export * from "./CategoryImagesField.vue?vue&type=script&lang=ts"
import style0 from "./CategoryImagesField.vue?vue&type=style&index=0&id=0ae7056c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae7056c",
  null
  
)

export default component.exports